module.exports = __webpack_public_path__ + "img/r-73.2cb320d8.jpg";